import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesFormGroupsForm } from './FormSamplesFormGroupsForm';
import { FormSamplesFormGroupsPageInfo } from './FormSamplesFormGroupsPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface CompanyCarLeasesDto {
    carLeaseId?: number;
    make: string;
    model: string;
    fromYear: number;
    toYear: number;
}

export interface PersonDto {
    personId?: number;
    firstName: string;
    lastName: string;
    email: string;
    carLeases?: CompanyCarLeasesDto[];
}

export interface DepartmentDto {
    departmentId?: number;
    departmentDesc: string;
    manager: PersonDto;
    supervisor: PersonDto;
}

export const FormSamplesFormGroupsPage = () => {

    /////////////////////////////////////////////////////////////////////////////////////////////
    // The initial values for the form.
    // This is passed as props to the form in the FormSamplesFormGroupsForm component.
    /////////////////////////////////////////////////////////////////////////////////////////////
    const initialValuesToBePassed: DepartmentDto = {
        departmentId: 4,
        departmentDesc: "Marketing",
        manager: {
            personId: 228,
            firstName: 'Peter',
            lastName: 'Piper',
            email: 'ppiper@test.com',
            carLeases: [
                { carLeaseId: 402, make: 'Toyota', model: 'Yaris', fromYear: 2002, toYear: 2008 },
                { carLeaseId: 404, make: 'Nissan', model: 'Leaf', fromYear: 2008, toYear: 2012 }
            ]
        },
        supervisor: {
            personId: 246,
            firstName: 'Karl',
            lastName: 'Johnson',
            email: 'kjohnson@test.com'
        }
    }

    const [submittedValues, setSubmittedValues] = useState<DepartmentDto | undefined>(undefined)
    const [submitting, setSubmitting] = useState(false);
    const { showError } = useFeedback();

    const handleSubmit = async (values: DepartmentDto) => {
        setSubmitting(true);
        setSubmittedValues(values);

        try {
            // In the api call, uncomment the exception in there to test errors coming from the api
            await callMimicApi();
        } catch (ex) {
            showError(`An error occured: ${ex}`);
            return false;
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <PageContainer
            heading='Form Samples - Form Groups'
            icon={<TextSnippetIcon />}
            pageInfo={<FormSamplesFormGroupsPageInfo />}
        >
            <PageDefaultSegment width={800}>
                <FormSamplesFormGroupsForm
                    initialValues={initialValuesToBePassed}
                    submitting={submitting}
                    onSubmit={handleSubmit}
                />
            </PageDefaultSegment>
            <FormSamplesOutput width={800} submittedValues={submittedValues} />
        </PageContainer>
    )
}
